import { Link } from "react-router-dom";
import { ArrowLeft, Phone, Mail } from "lucide-react";
import { CONTACT } from "./shared";

export const MobileBar = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-white/10 bg-nuit/95 backdrop-blur-md md:hidden" data-testid="mobile-action-bar">
    <a href={CONTACT.phoneHref} onClick={() => window.gtag?.("event", "click_phone")} data-testid="mobile-call-button" className="flex items-center justify-center gap-2 py-4 text-xs font-bold uppercase tracking-[0.12em] text-white">
      <Phone className="h-4 w-4 text-lagoon" /> Appeler
    </a>
    <a href={`mailto:${CONTACT.email}`} onClick={() => window.gtag?.("event", "click_email")} data-testid="mobile-email-button" className="flex items-center justify-center gap-2 border-x border-white/10 py-4 text-xs font-bold uppercase tracking-[0.12em] text-white">
      <Mail className="h-4 w-4 text-lagoon" /> E-mail
    </a>
    <Link to="/contact" data-testid="mobile-devis-button" className="flex items-center justify-center bg-lagoon py-4 text-xs font-bold uppercase tracking-[0.12em] text-nuit">
      Devis
    </Link>
  </div>
);

const Page = ({ title, children, testid }) => (
  <div className="min-h-screen bg-white pb-32 pt-32" data-testid={testid}>
    <div className="mx-auto max-w-3xl px-5 lg:px-10">
      <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.15em] text-petrole transition-colors duration-300 hover:text-lagoon">
        <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
      </Link>
      <h1 className="font-display mt-8 text-3xl font-medium tracking-tight text-nuit sm:text-4xl">{title}</h1>
      <div className="mt-10 space-y-6 text-sm leading-relaxed text-nuit/70">{children}</div>
    </div>
  </div>
);

export const MentionsLegales = () => (
  <Page title="Mentions légales" testid="mentions-legales-page">
    <p><strong className="text-nuit">Éditeur du site</strong><br />
      Rosset Conciergerie &amp; Services — une entreprise de Rosset Solutions<br />
      Steve Rosset<br />
      Route des Ecussons 10, 1950 Sion, Suisse<br />
      Téléphone : {CONTACT.phone} — E-mail : {CONTACT.email}<br />
      Site : {CONTACT.site}
    </p>
    <p><strong className="text-nuit">Hébergement</strong><br />
      [Hébergeur à compléter — Infomaniak Network SA, Genève, Suisse]
    </p>
    <p><strong className="text-nuit">Propriété intellectuelle</strong><br />
      L'ensemble des contenus de ce site (textes, visuels, logo) est la propriété de
      Rosset Conciergerie &amp; Services. Toute reproduction sans autorisation est interdite.
    </p>
  </Page>
);

export const Confidentialite = () => (
  <Page title="Politique de confidentialité" testid="confidentialite-page">
    <p>
      Rosset Conciergerie &amp; Services accorde une grande importance à la protection de vos
      données personnelles, conformément à la Loi fédérale sur la protection des données (LPD).
    </p>
    <p><strong className="text-nuit">Données collectées</strong><br />
      Via le formulaire de demande de devis : nom, coordonnées (téléphone, e-mail), localité,
      description de la demande et photos transmises volontairement.
    </p>
    <p><strong className="text-nuit">Utilisation</strong><br />
      Ces données sont utilisées exclusivement pour traiter votre demande, établir un devis
      et assurer le suivi de la relation client. Elles ne sont ni vendues, ni transmises à des
      tiers à des fins commerciales.
    </p>
    <p><strong className="text-nuit">Conservation et droits</strong><br />
      Les données sont conservées uniquement le temps nécessaire au traitement de votre demande.
      Vous pouvez à tout moment demander l'accès, la rectification ou la suppression de vos
      données en écrivant à {CONTACT.email}.
    </p>
    <p><strong className="text-nuit">Cookies et statistiques</strong><br />
      Ce site n'utilise pas de cookies de suivi publicitaire. Avec votre consentement explicite
      (bandeau affiché lors de votre première visite), nous utilisons Google Analytics 4
      (Google Ireland Ltd.) pour mesurer la fréquentation du site de manière anonymisée
      (adresse IP anonymisée, aucune donnée personnelle transmise). Vous pouvez refuser
      cette mesure sans aucune conséquence sur votre navigation, et modifier votre choix
      à tout moment en nous contactant.
    </p>
  </Page>
);


export const NotFound = () => (
  <div className="flex min-h-screen flex-col items-start justify-center bg-nuit px-5 pb-32 pt-32 lg:px-10" data-testid="not-found-page">
    <div className="mx-auto w-full max-w-3xl">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-lagoon">Erreur 404</p>
      <h1 className="font-display mt-4 text-4xl font-medium tracking-tight text-white sm:text-6xl">Cette page n'existe pas</h1>
      <p className="mt-6 max-w-md text-base leading-relaxed text-white/60">
        La page recherchée a peut-être été déplacée. Retrouvez nos services ou contactez-nous directement.
      </p>
      <div className="mt-10 flex flex-wrap gap-4">
        <Link to="/" data-testid="notfound-home" className="rounded-full bg-lagoon px-7 py-4 text-sm font-bold uppercase tracking-[0.12em] text-nuit transition-colors duration-300 hover:bg-white">
          Retour à l'accueil
        </Link>
        <Link to="/entretien-immeubles-ppe" data-testid="notfound-services" className="rounded-full border border-white/30 px-7 py-4 text-sm font-semibold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:border-lagoon hover:text-lagoon">
          Nos services
        </Link>
        <Link to="/contact" data-testid="notfound-contact" className="rounded-full border border-white/30 px-7 py-4 text-sm font-semibold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:border-lagoon hover:text-lagoon">
          Contact
        </Link>
      </div>
    </div>
  </div>
);
